import ProgressBar from 'olive-react-myoneui/lib/ProgressBar';
import ProgressValue from 'olive-react-myoneui/lib/ProgressValue';
import ProgressWrap from 'olive-react-myoneui/lib/ProgressWrap'; 
import Button from "olive-react-myoneui/lib/Button";
import { calendarIcon101, checkCircleIcon, rightArrowLong, stackIcon } from "../../constants/icons";

function CourseItem({
  className,
  courseId,
  courseImage,
  courseType,
  courseTitle,
  courseDeadline,
  courseLectureCount,
  courseEventCount,
  courseTypeLearning,
  courseStatus,
  courseButtonLabel,
  courseStartLink,
  courseDetailLink,
  courseResumeLink,
  courseProgressPercentage,
  isExpired,
}) {
  
  const startClickHandler = (link) => {
    if(isExpired) return false;
    if (link === '') return false;
    window.location.replace(link)
  };

  return (
    <div className={`myk__course-wrapper ${courseType ? courseType.toLowerCase() : ''} ${courseStatus === "inProgress" ? 'resumable-course' : ''}`}>
      <div className={`${className || ""} myk__course-block`}>
        <div className="myk__course-img">
          <img src={courseImage} className="img-fluid" />
        </div>
        <div className="myk__course-desc">
          {courseDeadline && <p>{calendarIcon101} {courseDeadline}</p>}
          <h1 key={courseId} onClick={() => startClickHandler(courseDetailLink)}>{courseTitle}</h1>
          <div className="myk__course-meta-data">
            {courseLectureCount && <span>{courseLectureCount} {courseType == "Bundle" ?  "Courses" : ""}</span>}
            {courseEventCount && <span>{courseEventCount} Events</span>}
            {courseTypeLearning && <span>{courseTypeLearning}</span>}
          </div>
          {courseStatus === "completed" && (
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white"
              size="sm"
              disabled
            >
             {checkCircleIcon} Completed
            </Button>
          )}
          
          {courseStatus === "inProgress" && courseProgressPercentage && (
            <>
            <ProgressWrap>
              <ProgressBar variant="success" now={courseProgressPercentage} />
              <ProgressValue ProgressPercentage={`${courseProgressPercentage}%`} />
            </ProgressWrap>
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white btn-resume"
              size="sm"
              onClick={() => startClickHandler(courseResumeLink)}
            >
              Resume Course {rightArrowLong}
            </Button>
            </>
          )}

          {courseStatus === "notStarted" && (
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white"
              size="sm"
              onClick={() => startClickHandler(courseStartLink)}
            >
              {courseButtonLabel} {rightArrowLong}
            </Button>
          )}
        </div>
      </div>
      {courseType && 
        <div className={`d-flex align-items-center justify-content-center gap-1 myk__dashboard-course-tag ${courseType ? courseType.toLowerCase() : ''}`}>
          {courseType === "Bundle" ?  
            <span>{stackIcon} {courseLectureCount} in 1</span> : 
            <span>{courseType}</span> 
          }
        </div>
      }
    </div>
  );
}

export default CourseItem;
